import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getAuthState } from '@/stores/auth.store';

export const Route = createFileRoute('/_verify-email')({
  beforeLoad: async ({ location }) => {
    const { accessToken, user } = getAuthState();

    if (!accessToken) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }

    // Already verified — send them onward.
    if (user?.emailVerified) {
      throw redirect({ to: user.accountSetupComplete ? '/' : '/account-setup' });
    }
  },
  component: VerifyEmailLayout,
});

function VerifyEmailLayout() {
  return <Outlet />;
}
